<template>
  <div v-if="voya" class="vt" role="tablist">
    <button
      v-for="(t, i) in tabs"
      :key="t.key"
      v-show="t.visible == undefined || t.visible()"
      type="button"
      role="tab"
      class="vt-btn"
      :class="{ 'vt-btn-active': value == t.key }"
      :aria-selected="value == t.key ? 'true' : 'false'"
      :accesskey="i + 1"
      @click="goTab(t.key)"
    >
      {{ t.text }}
    </button>
  </div>
  <ul v-else class="nav nav-tabs nav-fill" style="">
    <li
      v-for="(t, i) in tabs"
      :key="t.key"
      v-show="t.visible == undefined || t.visible()"
      class="nav-item"
    >
      <a
        class="nav-link"
        :accesskey="i + 1"
        :class="{ active: value == t.key }"
        href="#void"
        @click.prevent="goTab(t.key)"
      >
        <span v-if="bullets" class="bullet">{{ i + 1 }}</span>
        {{ t.text }}
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true
    },
    bullets: {
      type: Boolean,
      default: true
    },
    // true ise Voya (segmentli) görünümü kullanılır
    voya: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    currentTab() {
      return this.tabs.filter(x => x.key == this.value)[0];
    },
    tabIndex() {
      return this.tabs.indexOf(this.currentTab) || 0;
    },
    nextTab() {
      for (var i = this.tabIndex + 1; i < this.tabs.length; i++) {
        var tab = this.tabs[i];
        if (tab && (tab.visible == undefined || tab.visible())) {
          return tab;
        }
      }

      return null;
    },
    prevTab() {
      for (var i = this.tabIndex - 1; i >= 0; i--) {
        var tab = this.tabs[i];
        if (tab && (tab.visible == undefined || tab.visible())) {
          return tab;
        }
      }

      return null;
    }
  },
  methods: {
    goTab(key) {
      this.$emit("input", key);
      this.$emit("change", this.currentTab);
    },
    goNextTab() {
      if (this.nextTab) {
        this.$emit("input", this.nextTab.key);
        this.$emit("change", this.currentTab);
      }
    },
    goPrevTab() {
      if (this.prevTab) {
        this.$emit("input", this.prevTab.key);
        this.$emit("change", this.currentTab);
      }
    }
  }
};
</script>
<style scoped>
.vt {
  display: flex;
  gap: 4px;
  box-sizing: border-box;
  padding: 4px;
  border-radius: 12px;
  background-color: #EAEDF2;
}

.vt-btn {
  flex: 1 1 0;
  height: 40px;
  padding: 0 8px;
  border: none;
  border-radius: 9px;
  background: transparent;
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #808080;
}

.vt-btn-active {
  background-color: #ffffff;
  box-shadow: 0 1px 4px rgba(9, 33, 84, 0.12);
  font-weight: 600;
  color: #092154;
}

.bullet {
  vertical-align: middle;
  display: inline-block;
  border-radius: 1rem;
  color: #fff;
  width: 1rem;
  height: 1rem;
  background: #35495e;
  font-size: 0.7rem;
  font-weight: bold;
  margin-top: -0.15rem;
}
</style>
